import React from 'react';
import handL from "assets/img/newversion/whoweare-hand-rigth.png";
import handR from "assets/img/newversion/whoweare-hand-left.png";


export const MobileRightImage = () => {
  return (
    <div className="d-block d-md-none mb-3" style={{ overflow: 'hidden' }}>
      <img
        // src="https://api.builder.io/api/v1/image/assets/TEMP/a26fbef8dea549994976a5c5f23a8cc6da7036ae?width=782"
        src={handL}
        alt=""
        style={{
          opacity: 0.6,
          width: '200px',      // controla o "size"
          height: '100px',     // controla a altura visível
          objectFit: 'cover',  // corta excesso mantendo proporção
          objectPosition: 'center' // centraliza o corte
        }}
      />
    </div>
  );
};

export const MobileLeftImage = () => {
  return (
    <div className="d-block d-md-none text-end mt-3" style={{ overflow: 'hidden' }}>
      <img
        // src="https://api.builder.io/api/v1/image/assets/TEMP/f0948ae72ed7834342e5bec2bb3a5b7b451dcafb?width=554"
        src={handR}
        alt=""
        style={{
          opacity: 0.6,
          width: '150px',
          height: '50px',
          objectFit: 'cover',
          objectPosition: 'center'
        }}
      />
    </div>
  );
};